<template>
  <div class="training-questions-form-page">
    <b-loading :is-full-page="false" :active.sync="isSaving"></b-loading>
    <app-page-header
      :title="[
        training ? training.title : 'Treinamentos',
        'Perguntas',
        questionId ? 'Editar' : 'Cadastrar',
      ]"
      :loading="isLoading"
    >
      <button
        type="button"
        v-app-button.icon-left.clear
        v-app-back-button="{
          name: 'trainings.questions.index',
          params: { trainingId },
        }"
      >
        <b-icon size="is-small" icon="arrow-left"></b-icon>Voltar
      </button>
    </app-page-header>

    <app-card>
      <training-questions-form
        @submit="onSubmit"
        :id="questionId"
        :errors="errors"
        :saving="isSaving"
      ></training-questions-form>
    </app-card>
  </div>
</template>

<script>
import TrainingService from '@/services/training.service';
import TrainingQuestionService from '@/services/training-question.service';
import TrainingQuestionsForm from '@/components/Forms/TrainingQuestionsForm.vue';

export default {
  name: 'training-questions-form-page',
  components: {
    TrainingQuestionsForm,
  },
  data: () => {
    return {
      isLoading: true,
      training: null,
      trainingId: null,
      questionId: null,
      errors: {},
      isSaving: false,
    };
  },
  methods: {
    onSubmit(question) {
      this.questionId && this.update(this.questionId, question);
      !this.questionId && this.save(question);
    },
    save(question) {
      this.isSaving = true;
      TrainingQuestionService.save({
        ...question,
        training_id: this.trainingId,
      })
        .then(() => {
          this.toastify('Pergunta cadastrada com sucesso!');
          this.$router.push({
            name: 'trainings.questions.index',
            params: { trainingId: this.trainingId },
          });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar cadastrar Pergunta.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    update(id, question) {
      this.isSaving = true;
      TrainingQuestionService.update(id, question)
        .then(() => {
          this.toastify('Pergunta atualizada com sucesso.');
          this.$router.push({
            name: 'trainings.questions.index',
            params: { trainingId: this.trainingId },
          });
        })
        .catch(({ response }) => {
          const { message, errors } = response.data;

          if (response.status === 422) this.errors = errors;
          else
            this.toastify(
              message || 'Erro ao tentar atualizar Pergunta.',
              'error'
            );
        })
        .finally(() => (this.isSaving = false));
    },
    loadTraining(id) {
      TrainingService.getId(id)
        .then(({ data: training }) => (this.training = training))
        .finally(() => (this.isLoading = false));
    },
  },
  beforeMount() {
    this.trainingId = this.$route.params.trainingId;
    this.questionId = this.$route.params.id;
    this.loadTraining(this.trainingId);
  },
};
</script>
